import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import * as React from 'react';
import classNames from 'classnames';
import { LegacyDropdown } from '../../../dropdown/legacy-dropdown/index.js';
import '../../../utils/fetcher.js';
import { prependPrefix } from '../../../utils/style.js';
import '../../api/captcha.js';
import '@bilibili-maoer/web-utils';
import 'qs';
import { getRegions } from '../../api/region-selector.js';
import { DEFAULT_REGION } from '../../utils/constants.js';
export { DEFAULT_REGION } from '../../utils/constants.js';
import '../../../toast/index.js';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/core-js/parse-int';
import '@babel/runtime-corejs3/core-js/object/keys';
import { requestWithRetry } from '../../utils/retry.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var RegionSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(RegionSelector, _React$Component);

  var _super = _createSuper(RegionSelector);

  function RegionSelector(props) {
    var _this;

    _classCallCheck(this, RegionSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (region) {
      var onSelect = _this.props.onSelect;
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(region);

      _this.setState({
        region: region
      });
    });

    var _this$props = _this.props,
        _this$props$defaultVa = _this$props.defaultValue,
        defaultValue = _this$props$defaultVa === void 0 ? DEFAULT_REGION : _this$props$defaultVa,
        value = _this$props.value;
    var initRegion = value || defaultValue;
    _this.state = {
      region: initRegion,
      regionList: [initRegion]
    };
    return _this;
  }

  _createClass(RegionSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      requestWithRetry(getRegions).then(function (res) {
        var _res$info;

        if (res.success && (_res$info = res.info) !== null && _res$info !== void 0 && _res$info.length) {
          _this2.setState({
            regionList: res.info
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _context,
          _currentRegion$name,
          _currentRegion$value,
          _this3 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          disableZoneCode = _this$props2.disableZoneCode,
          selectedRegion = _this$props2.value,
          dropdownClassName = _this$props2.dropdownClassName,
          dropdownSelectedClassName = _this$props2.dropdownSelectedClassName;
      var _this$state = this.state,
          region = _this$state.region,
          regionList = _this$state.regionList;
      var currentRegion = selectedRegion || region;

      var regionValue = _concatInstanceProperty(_context = "".concat((_currentRegion$name = currentRegion === null || currentRegion === void 0 ? void 0 : currentRegion.name) !== null && _currentRegion$name !== void 0 ? _currentRegion$name : '')).call(_context, disableZoneCode ? '' : " (+".concat((_currentRegion$value = currentRegion === null || currentRegion === void 0 ? void 0 : currentRegion.value) !== null && _currentRegion$value !== void 0 ? _currentRegion$value : '', ")"));

      return /*#__PURE__*/React.createElement(LegacyDropdown, {
        className: classNames(prependPrefix('region-selector'), className),
        dropdownClassName: classNames('region-dropdown-menu', dropdownClassName),
        dropdownSelectedClassName: classNames('region-select-item', dropdownSelectedClassName),
        value: regionValue
      }, _mapInstanceProperty(regionList).call(regionList, function (_ref) {
        var _context2, _context3;

        var code = _ref.code,
            value = _ref.value,
            name = _ref.name;
        return /*#__PURE__*/React.createElement("li", {
          key: code,
          className: "region-dropdown-item",
          title: _concatInstanceProperty(_context2 = "".concat(name)).call(_context2, disableZoneCode ? '' : " (+".concat(value, ")")),
          onClick: function onClick() {
            return _this3.handleSelect({
              code: code,
              value: value,
              name: name
            });
          }
        }, _concatInstanceProperty(_context3 = "".concat(name)).call(_context3, disableZoneCode ? '' : " (+".concat(value, ")")));
      }));
    }
  }]);

  return RegionSelector;
}(React.Component);

export { RegionSelector };
